/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useParams, useHistory, useRouteMatch } from 'react-router-dom';
import {
  Box, Typography, Grid, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Button, Skeleton,
} from '@mui/material';
import StatusBadge from 'Shared/UI/StatusBadge';
import AppButton from 'Shared/UI/Button';
import ConfirmReceptionDialog from './ConfirmReceptionDialog';
import Toast from '../../Shared/UI/Toast';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CheckIcon from '@mui/icons-material/Check';
import infomationsCardIcon from '../../Images/infomations_card_icon.svg';
import adresseCardIcon from '../../Images/adresse_card_icon.svg';
import transportCardIcon from '../../Images/transport_card_icon.svg';
import conditionCardIcon from '../../Images/icon_card_document.svg';
import iconCardTransportation from '../../Images/icon_card_transportation.svg';
import ponneCardIcon from '../../Images/phone_icon.svg';
import iconCardDate from '../../Images/icon_card_date.svg';
import noImage from '../../Images/no_image.svg';
import checkIcon from '../../Images/check_icon.svg';
import xIcon from '../../Images/X_icon.svg';
import useNetworkLoader from 'hooks/useNetworkLoader';
import { formatAmount } from 'Utils/ulilities';
import { getCommandeDetail, getSalesCommandeDetail, confirmDelivery, confirmSalesDelivery, downloadOrderFacture } from './OrdersServices';

/* ── Info card ────────────────────────────────────────────────────── */
const InfoCard = ({ icon: Icon, iconSrc, title, children, bgColor }) => (
  <Box sx={{ backgroundColor: bgColor || '#fff', border: '2px solid #E8ECF0', borderRadius: '12px', p: '18px 20px', width: '100%', height: '130px', boxSizing: 'border-box', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06)' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', mb: '14px' }}>
      <Box sx={{ width: 32, height: 32, borderRadius: '50%', backgroundColor: 'rgba(131, 151, 174, 0.21)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {iconSrc
          ? <Box sx={{ width: 14, height: 14, backgroundColor: '#385576', WebkitMaskImage: `url(${iconSrc})`, WebkitMaskRepeat: 'no-repeat', WebkitMaskSize: 'contain', WebkitMaskPosition: 'center', maskImage: `url(${iconSrc})`, maskRepeat: 'no-repeat', maskSize: 'contain', maskPosition: 'center' }} />
          : <Icon sx={{ fontSize: 18, color: '#385576' }} />}
      </Box>
      <Typography sx={{ fontSize: '16px', fontWeight: 700, color: '#8397AE',ml:'6px' }}>{title}</Typography>
    </Box>
    {children}
  </Box>
);

const InfoRow = ({ label, value }) => (
  <Box sx={{ mb: '8px' }}>
    <Typography sx={{ fontSize: '12.5px', fontWeight: 600, color: '#385576', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</Typography>
    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182', mt: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{value || '—'}</Typography>
  </Box>
);

/* ── Timeline ────────────────────────────────────────────────────── */
const STEP_DESCRIPTIONS = {
  'Envoyée': 'Votre commande a bien été reçue.',
  'En Cours De Traitement': 'Votre commande est en cours de traitement.',
  'Traitée': 'Votre commande a été traitée.',
  'Réception confirmée': 'La réception de la commande a été confirmée.',
};

const TimelinePanel = ({ timeline = [], confirmedAt }) => (
  <Box sx={{ pt: '8px', pb: '18px', px: '20px', mr: '-22px', ml: '-28px' }}>
    <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#000000', mb: '12px' }}>
      Avancement de la commande
    </Typography>
    {timeline.map((step, i) => {
      const nextStep = timeline[i + 1];
      const isNextDone = nextStep?.reached || (i === timeline.length - 1 && confirmedAt);
      return (
        <Box key={step.label}>
          <Box sx={{
            display: 'flex', alignItems: 'flex-start', gap: '12px',
            p: '14px 20px', borderRadius: '8px', mb: '6px',
            border: `2px solid ${step.reached ? '#027BC6' : '#D1D5DD'}`,
            backgroundColor: '#FFFFFF',
          }}>
            <Box sx={{ flexShrink: 0, mt: '4px' }}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: step.reached ? '#027BC6' : '#D1D5DD' }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: step.reached ? '#007BC6' : '#D1D5DD' }}>
                  {step.label === 'En Cours De Traitement' ? 'En cours de traitement' : step.label}
                </Typography>
                {step.reached && step.date && (
                  <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#8397AE', whiteSpace: 'nowrap', ml: '8px' }}>
                    {new Date(step.date).toLocaleString('fr-FR')}
                  </Typography>
                )}
              </Box>
              <Typography sx={{ fontSize: '12px', fontWeight: 500, color: step.reached ? '#385576' : '#D1D5DD', mt: '2px' }}>
                {STEP_DESCRIPTIONS[step.label] || ''}
              </Typography>
            </Box>
          </Box>
          {i < timeline.length - 1 && (
            <Box sx={{ ml: '19px', width: '2px', height: '10px', backgroundColor: step.reached && isNextDone ? '#027BC6' : '#D1D5DD', mb: '2px', mt: '-4px' }} />
          )}
        </Box>
      );
    })}
    {confirmedAt && (
      <>
        <Box sx={{ ml: '19px', width: '2px', height: '10px', backgroundColor: '#0AD69F', mb: '2px', mt: '-4px' }} />
        <Box sx={{
          display: 'flex', alignItems: 'flex-start', gap: '12px',
          p: '14px 20px', borderRadius: '8px', mb: '6px',
          border: '2px solid #0AD69F',
          backgroundColor: '#FFFFFF',
        }}>
          <Box sx={{ flexShrink: 0, mt: '4px' }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#0AD69F' }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#0AD69F' }}>
                Réception confirmée
              </Typography>
              <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#8397AE', whiteSpace: 'nowrap', ml: '8px' }}>
                {new Date(confirmedAt).toLocaleString('fr-FR')}
              </Typography>
            </Box>
            <Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#385576', mt: '2px' }}>
              {STEP_DESCRIPTIONS['Réception confirmée']}
            </Typography>
          </Box>
        </Box>
      </>
    )}
  </Box>
);

/* ── Product group table ──────────────────────────────────────────── */
const ProductGroup = ({ label, count, products = [], isDelivered }) => {
  const headerBg = isDelivered ? '#EFF8F0' : '#FFF7ED';
  const rowBg = isDelivered ? '#E7F5E9' : '#FFF7ED';
  const borderColor = isDelivered ? '#C7E6C9' : '#FED7AA';
  const labelColor = isDelivered ? '#0AD69F' : '#FEA26F';
  const thGroupSx = { ...thSx, backgroundColor: headerBg, borderBottom: `1px solid ${borderColor}` };

  return (
    <Box sx={{ mb: '16px', '& *': {  } }}>
      <TableContainer sx={{ border: `1px solid ${borderColor}`, borderRadius: '8px' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: rowBg }}>
              {/* Label cell */}
              <TableCell sx={{ ...thGroupSx, width: '45%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img src={isDelivered ? checkIcon : xIcon} alt="" style={{ width: 14, height: 14, objectFit: 'contain' }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 700, color: labelColor, textTransform: 'uppercase' }}>
                    {label} ({count})
                  </Typography>
                </Box>
              </TableCell>
              <TableCell sx={{ ...thGroupSx, width: '18%' }}>Prix Unitaire Brut TTC</TableCell>
              <TableCell sx={{ ...thGroupSx, width: '13.75%' }}>Quantité</TableCell>
              <TableCell sx={{ ...thGroupSx, width: '13.75%' }}>Remise</TableCell>
              <TableCell sx={{ ...thGroupSx, width: '13.75%' }}>Total Net TTC</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((detail, i) => {
              const remise = parseFloat(detail.remise) || 0;
              const qty = detail.quantity || 1;
              const price = parseFloat(detail.prixUnitaireBrutTtc) || 0;
              const totalNet = parseFloat(detail.totalNetTtc) || price * (1 - remise / 100) * qty;
              return (
                <TableRow key={i} sx={{ backgroundColor: rowBg }}>
                  <TableCell sx={tdSx}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <Box sx={{ width: 36, height: 36, backgroundColor: '#e0e4e9', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
                        {detail.image
                          ? <img src={detail.image} alt="product" style={{ width: 36, height: 36, objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
                          : null}
                        <img src={noImage} alt="product" style={{ width: 36, height: 36, objectFit: 'contain', display: detail.image ? 'none' : 'block' }} />
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#000000' }}>{detail.name || '—'}</Typography>
                        <Typography sx={{ fontSize: '14px', color: '#8397AE' }}>RÉF: {detail.reference || '—'}</Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={tdSx}>{formatAmount(price)}</TableCell>
                  <TableCell sx={tdSx}>{qty}</TableCell>
                  <TableCell sx={tdSx}>{remise > 0 ? `${remise}%` : '—'}</TableCell>
                  <TableCell sx={tdSx}>{formatAmount(totalNet)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

const thSx = { fontSize: '13px', fontWeight: 600, color: '#385576', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #DEE5EE', py: '4px', px: '12px' };
const tdSx = { fontSize: '14px', color: '#000000', fontWeight: 600, borderBottom: '1.5px solid #DEE5EE', py: '6px', px: '12px' };

/* ── Flat articles table (Envoyée / En Cours) ─────────────────────── */
const ArticlesTable = ({ products = [] }) => (
  <TableContainer sx={{ border: '1px solid #DEE5EE', borderRadius: '8px' }}>
    <Table size="small">
      <TableHead>
        <TableRow sx={{ backgroundColor: '#F8FAFC' }}>
          <TableCell sx={{ ...thSx, width: '45%' }}>Article</TableCell>
          <TableCell sx={{ ...thSx, width: '18%' }}>Prix Unitaire Brut TTC</TableCell>
          <TableCell sx={{ ...thSx, width: '13.75%' }}>Quantité</TableCell>
          <TableCell sx={{ ...thSx, width: '13.75%' }}>Remise</TableCell>
          <TableCell sx={{ ...thSx, width: '13.75%' }}>Total Net TTC</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {products.map((detail, i) => {
          const remise = parseFloat(detail.remise) || 0;
          const price = parseFloat(detail.prixUnitaireBrutTtc) || 0;
          const qty = detail.quantity || 1;
          const totalNet = parseFloat(detail.totalNetTtc) || price * (1 - remise / 100) * qty;
          return (
            <TableRow key={i} sx={{ backgroundColor: i % 2 === 0 ? '#fff' : '#F8FAFC' }}>
              <TableCell sx={tdSx}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Box sx={{ width: 36, height: 36, backgroundColor: '#e0e4e9', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
                    {detail.image
                      ? <img src={detail.image} alt="product" style={{ width: 36, height: 36, objectFit: 'contain' }} onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }} />
                      : null}
                    <img src={noImage} alt="product" style={{ width: 36, height: 36, objectFit: 'contain', display: detail.image ? 'none' : 'block' }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#000000' }}>{detail.name || '—'}</Typography>
                    <Typography sx={{ fontSize: '14px', color: '#8397AE' }}>RÉF: {detail.reference || '—'}</Typography>
                  </Box>
                </Box>
              </TableCell>
              <TableCell sx={tdSx}>{formatAmount(price)}</TableCell>
              <TableCell sx={tdSx}>{qty}</TableCell>
              <TableCell sx={tdSx}>{remise > 0 ? `${remise}%` : '—'}</TableCell>
              <TableCell sx={tdSx}>{formatAmount(totalNet)}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);

/* ── Main OrderDetail component ───────────────────────────────────── */
const OrderDetail = () => {
  const { id } = useParams();
  const history = useHistory();
  const isSalesRoute = !!useRouteMatch('/orders/sales/:id');
  const { callApi } = useNetworkLoader();
  const [detail, setDetail] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [toast, setToast] = useState({ open: false, message: '' });
  const [downloadingOrder, setDownloadingOrder] = useState(false);

  useEffect(() => {
    if (id) {
      const fetcher = isSalesRoute ? () => getSalesCommandeDetail(id) : () => getCommandeDetail(id);
      callApi(fetcher, (data) => setDetail(data));
    }
  }, [id, isSalesRoute]);

  const handleDownload = async () => {
    const ref = detail?.factureReference;
    if (!ref) return;
    setDownloadingOrder(true);
    try {
      const blob = await downloadOrderFacture(ref);
      const url = window.URL.createObjectURL(new Blob([blob.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `facture-${ref}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) { console.error('[downloadFacture]', e); }
    finally { setDownloadingOrder(false); }
  };

  const handleConfirm = () => {
    const apiCall = isSalesRoute ? () => confirmSalesDelivery(id) : () => confirmDelivery(id);
    const reloadCall = isSalesRoute ? () => getSalesCommandeDetail(id) : () => getCommandeDetail(id);
    callApi(apiCall, () => {
      setConfirmOpen(false);
      setToast({ open: true, message: 'Réception de la commande confirmée avec succès' });
      callApi(reloadCall, (data) => setDetail(data), false);
    });
  };

  if (!detail) return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#F8FAFC', pt: '90px', px: { xs: '16px', md: '40px' }, pb: '40px', mt: '-80px' }}>
      <Box sx={{ mb: '20px' }}>
        <Skeleton variant="text" width={160} height={20} sx={{ mb: '8px' }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', mb: '6px' }}>
          <Skeleton variant="text" width={320} height={30} />
          <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: '20px' }} />
        </Box>
        <Skeleton variant="text" width={240} height={22} />
      </Box>
      <Grid container spacing={1} sx={{ mb: '24px' }}>
        {[0, 1, 2, 3].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box sx={{ backgroundColor: '#fff', border: '2px solid #E8ECF0', borderRadius: '12px', p: '18px 20px', height: '130px' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', mb: '14px' }}>
                <Skeleton variant="circular" width={32} height={32} />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
              <Skeleton variant="text" width="80%" height={16} />
              <Skeleton variant="text" width="60%" height={16} />
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={9}>
          <Skeleton variant="text" width={140} height={28} sx={{ mb: '16px' }} />
          {[0, 1, 2].map((i) => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: '10px', mb: '12px' }}>
              <Skeleton variant="rectangular" width={36} height={36} sx={{ borderRadius: '6px', flexShrink: 0 }} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="35%" height={18} />
                <Skeleton variant="text" width="20%" height={14} />
              </Box>
              <Skeleton variant="text" width={60} height={18} />
              <Skeleton variant="text" width={30} height={18} />
              <Skeleton variant="text" width={60} height={18} />
            </Box>
          ))}
        </Grid>
        <Grid item xs={12} md={3}>
          <Skeleton variant="text" width={200} height={24} sx={{ mb: '12px' }} />
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} variant="rectangular" width="100%" height={65} sx={{ borderRadius: '8px', mb: '10px' }} />
          ))}
        </Grid>
      </Grid>
    </Box>
  );

  const isTraitee = detail.statut === 'Traitée';
  const isConfirmed = detail.deliveryConfirmedAt != null;
  const produitsLivres = detail.produitsLivres || [];
  const produitsNonLivres = detail.produitsNonLivres || [];

  // Align timeline with the computed statut to avoid mismatch
  const STATUT_ORDER = ['Envoyée', 'En Cours De Traitement', 'Traitée'];
  const statutIdx = STATUT_ORDER.indexOf(detail.statut);
  const timeline = (detail.timeline || []).map((step) => {
    const stepIdx = STATUT_ORDER.indexOf(step.label);
    if (stepIdx === -1) return step;
    return { ...step, reached: stepIdx <= statutIdx };
  });

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#F8FAFC', pt: '90px', px: { xs: '16px', md: '40px' }, pb: '40px', mt: '-80px' }}>

      {/* Back + Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '20px', flexWrap: 'wrap', gap: '12px' }}>
        <Box>
          <Box onClick={() => history.goBack()} sx={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', mb: '8px' }}>
            <ArrowBackIosNewIcon sx={{ fontSize: 11, color: '#8397AE' }} />
            <Typography sx={{ fontSize: '14px', color: '#8397AE', fontWeight: 600 }}>Retour aux commandes</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#385576' }}>
              Détails de la commande: <Box component="span" sx={{ color: '#000000' }}>{detail.numeroCommande}</Box>
            </Typography>
            <Box sx={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: isSalesRoute ? '55px' : '52px', height: '29px',
              borderRadius: '8px',
              backgroundColor: isSalesRoute ? 'rgba(15,186,129,0.06)' : '#027BC617',
              color: isSalesRoute ? '#0FBA81' : '#007BC6',
              fontSize: '12px', fontWeight: 700, textTransform: 'capitalize',
            }}>
              {isSalesRoute ? 'Sales' : 'Edge'}
            </Box>
            <StatusBadge status={detail.statut} />
          </Box>
          <Typography sx={{ fontSize: '16px', fontWeight: 600, color: '#385576', mt: '2px' }}>
            Montant Total net TTC:{' '}
            <Box component="span" sx={{ fontWeight: 700, color: '#007BC6' }}>
              {formatAmount(detail.montantTotal || 0)} DH
            </Box>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {isTraitee && !isConfirmed && (
            <Button
              variant="contained"
              startIcon={<CheckIcon />}
              onClick={() => setConfirmOpen(true)}
              sx={{ backgroundColor: '#0AD69F', textTransform: 'none', fontWeight: 600, fontSize: '13px', borderRadius: '8px', px: '20px', width: '202px', height: '42px', '&:hover': { backgroundColor: '#08b886' }, whiteSpace: 'nowrap' }}
            >
              Confirmer la réception
            </Button>
          )}
          {detail.factureReference && (
            <AppButton
              variant="custom"
              label="Télécharger facture"
              icon={<FileDownloadOutlinedIcon />}
              color="#007BC6"
              hoverColor="#005F9E"
              textColor="#FFFFFF"
              onClick={handleDownload}
              loading={downloadingOrder}
              sx={{ height: '42px', px: '20px', whiteSpace: 'nowrap' }}
            />
          )}
        </Box>
      </Box>

      <Grid container spacing={1} sx={{ mb: '24px' }}>
        <Grid item xs={12} sm={6} md={3}>
          <InfoCard iconSrc={infomationsCardIcon} title="Informations">
            <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
              <Box sx={{ flex: 1 }}>
                <InfoRow label="N° D'Expédition" value={detail.nExpedition ? `# ${detail.nExpedition}` : '—'} />
              </Box>
              <Box sx={{ width: '0.5px', backgroundColor: '#E2E8F0', flexShrink: 0, height: '32px', mt: '6px', mr: '2px' }} />
              <Box sx={{ flex: 1, pl: '6px' }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#385576', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Date</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                  <Box sx={{ width: 12, height: 12, backgroundColor: '#385576', WebkitMaskImage: `url(${iconCardDate})`, WebkitMaskRepeat: 'no-repeat', WebkitMaskSize: 'contain', WebkitMaskPosition: 'center', maskImage: `url(${iconCardDate})`, maskRepeat: 'no-repeat', maskSize: 'contain', maskPosition: 'center', flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182' }}>{detail.dateFacture ? new Date(detail.dateFacture).toLocaleDateString('fr-FR') : '—'}</Typography>
                </Box>
              </Box>
            </Box>
          </InfoCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <InfoCard iconSrc={adresseCardIcon} title="Adresse de livraison">
            <Box sx={{ display: 'flex', alignItems: 'stretch', justifyContent: 'space-between' }}>
              <Box>
                <InfoRow label={detail.city || 'Adresse'} value={detail.adresse || '—'} />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                  <Box sx={{ width: 12, height: 12, backgroundColor: '#385576', WebkitMaskImage: `url(${ponneCardIcon})`, WebkitMaskRepeat: 'no-repeat', WebkitMaskSize: 'contain', WebkitMaskPosition: 'center', maskImage: `url(${ponneCardIcon})`, maskRepeat: 'no-repeat', maskSize: 'contain', maskPosition: 'center', flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#385576' }}>{detail.phone || '—'}</Typography>
                </Box>
              </Box>
            </Box>
          </InfoCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <InfoCard iconSrc={transportCardIcon} title="Colis & Transport">
            <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: '12.5px', fontWeight: 600, color: '#385576', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Nombre De Colis</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                  <Box sx={{ width: 12, height: 12, backgroundColor: '#385576', WebkitMaskImage: `url(${transportCardIcon})`, WebkitMaskRepeat: 'no-repeat', WebkitMaskSize: 'contain', WebkitMaskPosition: 'center', maskImage: `url(${transportCardIcon})`, maskRepeat: 'no-repeat', maskSize: 'contain', maskPosition: 'center', flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182' }}>{detail.nombreColis ?? '—'}</Typography>
                </Box>
              </Box>
              <Box sx={{ width: '0.5px', backgroundColor: '#E2E8F0', flexShrink: 0, height: '33px', mt: '6px', mr: '3px' }} />
              <Box sx={{ flex: 1, pl: '6px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Typography sx={{ fontSize: '12.5px', fontWeight: 600, color: '#385576', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Transporteur</Typography>
                  {!isTraitee && detail.transporteur && (
                    <Box sx={{ px: '4px', py: '0px', backgroundColor: '#F1F5F9', borderRadius: '3px', border: '1px solid #E2E8F0' }}>
                      <Typography sx={{ fontSize: '8px', fontWeight: 600, color: '#8397AE', letterSpacing: '0.2px' }}>Sélectionné</Typography>
                    </Box>
                  )}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                  <Box sx={{ width: 12, height: 12, backgroundColor: '#385576', WebkitMaskImage: `url(${iconCardTransportation})`, WebkitMaskRepeat: 'no-repeat', WebkitMaskSize: 'contain', WebkitMaskPosition: 'center', maskImage: `url(${iconCardTransportation})`, maskRepeat: 'no-repeat', maskSize: 'contain', maskPosition: 'center', flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182' }}>{detail.transporteur || '—'}</Typography>
                </Box>
              </Box>
            </Box>
          </InfoCard>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <InfoCard iconSrc={conditionCardIcon} title="Conditions générales">
            <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: '12.5px', fontWeight: 600, color: '#385576', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Conditions De Livraison</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                  <Box sx={{ width: 12, height: 12, backgroundColor: '#385576', WebkitMaskImage: `url(${iconCardTransportation})`, WebkitMaskRepeat: 'no-repeat', WebkitMaskSize: 'contain', WebkitMaskPosition: 'center', maskImage: `url(${iconCardTransportation})`, maskRepeat: 'no-repeat', maskSize: 'contain', maskPosition: 'center', flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182' }}>{detail.conditionsLivraison === 'PORT_PAYE' ? 'Port payé' : detail.conditionsLivraison === 'PORT_DU' ? 'Port dû' : detail.conditionsLivraison || '—'}</Typography>
                </Box>
              </Box>
              <Box sx={{ width: '0.5px', backgroundColor: '#E2E8F0', flexShrink: 0, height: '30px', ml: '3px', mr: '5px', mt: '6px' }} />
              <Box sx={{ flex: 1, pl: '4px' }}>
                <Typography sx={{ fontSize: '12.5px', fontWeight: 600, color: '#385576', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Conditions De Paiement</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mt: '2px' }}>
                  <Box sx={{ width: 12, height: 12, backgroundColor: '#385576', WebkitMaskImage: `url(${infomationsCardIcon})`, WebkitMaskRepeat: 'no-repeat', WebkitMaskSize: 'contain', WebkitMaskPosition: 'center', maskImage: `url(${infomationsCardIcon})`, maskRepeat: 'no-repeat', maskSize: 'contain', maskPosition: 'center', flexShrink: 0 }} />
                  <Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#717182' }}>{detail.conditionsPaiement || '—'}</Typography>
                </Box>
              </Box>
            </Box>
          </InfoCard>
        </Grid>
      </Grid>

      {/* Articles + Timeline */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={9}>
          <Box sx={{ p: '4px' }}>
            {isTraitee ? (
              <>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#000000', mb: '16px' }}>
                  Articles ({produitsLivres.length + produitsNonLivres.length})
                </Typography>
                {produitsLivres.length > 0 && (
                  <ProductGroup label="Produits livrés" count={produitsLivres.length} products={produitsLivres} isDelivered />
                )}
                {produitsNonLivres.length > 0 && (
                  <ProductGroup label="Produits non livrés" count={produitsNonLivres.length} products={produitsNonLivres} isDelivered={false} />
                )}
              </>
            ) : produitsNonLivres.length > 0 && (
              <>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#000000', mb: '16px' }}>
                  Articles ({produitsNonLivres.length})
                </Typography>
                <ArticlesTable products={produitsNonLivres} />
              </>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <TimelinePanel timeline={timeline} confirmedAt={detail.deliveryConfirmedAt} />
        </Grid>
      </Grid>

      <ConfirmReceptionDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
      />

      <Toast
        open={toast.open}
        message={toast.message}
        severity="success"
        onClose={() => setToast((t) => ({ ...t, open: false }))}
      />
    </Box>
  );
};

export default OrderDetail;